import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Button, Input, Form, Modal } from "antd";
import { Link } from "react-router-dom";
import { editProfile } from "../../../services/login";
import { regExp } from "../../../config";
import { checkAuth } from "../../../store/loginAction";
import { useSelector, useDispatch } from "react-redux";

const EditProfile = props => {
  const user = useSelector(state => state.loginUser);
  const dispatch = useDispatch();
  useEffect(() => {
    if (user) {
      const { _id, firstName, lastName, emailId, mobileNo } = user;
      setFirstName(firstName);
      setLastName(lastName);
      setEmail(emailId);
      setMobile(mobileNo);
      setId(_id);
    }
  }, [user]);

  const [id, setId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstnameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");

  const onSubmit = async () => {
    if (validation()) {
      const userInfo = {
        firstName,
        lastName,
        mobileNo: mobile
      };
      const token = localStorage.token;
      const res = await editProfile(id, userInfo, token);

      dispatch(checkAuth(token, props));
      if (res.data && res.data.success) {
        Modal.success({
          width: 520,
          //title: "A verification link has been sent to your email account",
          content: (
            <div>
              <p>Profile updated Successfuly!</p>
            </div>
          ),
          onOk() {
            //props.history.push("/signin");
          }
        });
      }
    }
  };

  const validation = () => {
    setFirstnameError("");
    setLastNameError("");

    setMobileError("");

    let formIsValid = true;
    if (!firstName) {
      formIsValid = false;
      setFirstnameError({ e: "error", message: "Enter First Name" });
    }
    if (!lastName) {
      formIsValid = false;
      setLastNameError({ e: "error", message: "Enter Last Name" });
    }

    if (!mobile) {
      formIsValid = false;
      setMobileError({ e: "error", message: "Enter Mobile Number" });
    } else {
      if (!regExp.phone.test(mobile)) {
        formIsValid = false;
        setMobileError({ e: "error", message: "Enter a valid Moblie Number" });
      }
    }

    return formIsValid;
  };

  return (
    <div className="app flex-row align-items-center" style={{ marginTop: 50 }}>
      <div className="card w-50" style={{ margin: "auto", border: "none" }}>
        <div className="card-title">
          <Link to="/profile">
            <i className="fas fa-chevron-left"></i> Back to Profile
          </Link>
        </div>
        <div className="card-body">
          <h4>Edit Profile</h4>
          <Form>
            <Form.Item
              //label="First Name"
              validateStatus={firstNameError.e}
              help={firstNameError.message}
            >
              <Input
                type="text"
                name="firstName"
                value={firstName}
                placeholder="First Name"
                onChange={e => setFirstName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              validateStatus={lastNameError.e}
              help={lastNameError.message}
            >
              <Input
                type="text"
                name="lastName"
                value={lastName}
                placeholder="Last Name"
                onChange={e => setLastName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              validateStatus={mobileError.e}
              help={mobileError.message}
            >
              <Input
                type="text"
                name="mobileNumber"
                value={mobile}
                placeholder="Mobile Number"
                onChange={e => setMobile(e.target.value)}
              />
            </Form.Item>
            <Form.Item>
              <Input
                type="text"
                name="email"
                value={email}
                placeholder="Email"
                disabled
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" onClick={onSubmit}>
                Confirm
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
